import "./Studio.module.css";
import Header from "@/reusable_sections/Header";
import IdentityAndMethod from "./sections/IdentityAndMethod";
import ValoriProfessionali from "./sections/ValoriProfessionali";
import ServicesShowcase from "./sections/ServicesShowcase";
import DcLegalProfessionals from "./sections/DcLegalProfessionals";
import Valori from "./sections/Valori";
import Footer from "@/reusable_sections/Footer";
export default function StudioPage() {
  return <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <ServicesShowcase />
        <ValoriProfessionali />
        <IdentityAndMethod />
        <DcLegalProfessionals />
      </main>
      <Valori />
      <Footer />
    </div>;
}